import React, { Component, Fragment } from "react";
import Popup from "reactjs-popup";
import {
  FormControl,
  ControlLabel,
  Row,
  Col,
  FormGroup,
  Radio,
} from "react-bootstrap";
import LoaderButton from "./LoaderButton";
import { selectedFilesSendEmail, archiveFolder } from "../libs/API";

class EmailPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupOpen: false,
      emailInputField: "",
      bcc: "",
      cc: "",
      selectedDay: "",
      isLoading: false,
      isChecked: "original",
      deliveryMode: "multipleLinks",
      bundleLinkName: "",
      hasRedaction: false,
      pageFrom: -1,
      pageTo: -1,
    };
    // console.log("email popup props", props);
  }

  async componentDidMount() {
    this.setState({ popupOpen: this.props.props.showEmailPopup });
    if (!this.props.props.isArchivePopup) await this.checkRedaction();
  }

  checkRedaction = async () => {
    let fileArray = this.props.props.fileIdArray;
    let redaction = fileArray.some((x) => x.redaction === true);
    this.setState({ hasRedaction: redaction });
  };

  closePopup = () => {
    this.setState({ popupOpen: false });
    this.props.unmountMe();
  };

  handleEmailSubmit = async (e) => {
    e.preventDefault();
    const bundleLinkName = this.state.bundleLinkName.trim();
    if (this.state.deliveryMode === "singleBundleLink" && !bundleLinkName) {
      alert("Please enter a bundle link name.");
      return;
    }

    this.setState({ isLoading: true });
    let emailParams = {
      fileData: this.props.props.fileIdArray,
      hasManageRedaction: this.props.props.manageRedaction,
      selectedOption: this.state.isChecked,
      deliveryMode: this.state.deliveryMode,
      bundleLinkName:
        this.state.deliveryMode === "singleBundleLink" ? bundleLinkName : "",
      emailTo: this.state.emailInputField,
      ccs: this.state.cc,
      bccs: this.state.bcc,
      selectedDay: this.state.selectedDay,
      pageFrom: this.state.pageFrom,
      pageTo: this.state.pageTo,
    };
    selectedFilesSendEmail(emailParams).then((data) => {
      this.setState({ isLoading: false });
      if (data.status === 200) {
        this.closePopup();
      } else if (data.status === 202) {
        alert("Email is being processed. You will receive it shortly.");
        this.closePopup();
      } else {
        alert("Unable to send email. Please try again.");
      }
    });
  };

  handleArchiveEmailSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });

    const response = await archiveFolder(
      this.props.props.rowData,
      this.props.props.selectedClientId,
      this.state.emailInputField,
      this.state.cc,
    );
    this.closePopup();
  };

  handleRadioChange = (e) => {
    const value = e.target.value;
    this.setState({ isChecked: value });
  };

  render() {
    const rowStyle = {
      marginBottom: "0.4rem",
    };

    return (
      <Fragment>
        <Popup
          contentStyle={{
            width: "32%",
            borderRadius: "15px",
            padding: "15px",
          }}
          open={this.state.popupOpen}
          modal
          closeOnDocumentClick={false}
          onClose={this.closePopup}
        >
          <div>
            <a className="close" onClick={this.closePopup}>
              &times;
            </a>
            <div>
              <h3>Send Email</h3>
              {!this.props.props.isArchivePopup ? (
                <form onSubmit={this.handleEmailSubmit}>
                  <FormGroup>
                    {/* Email Original or Redacted Options */}
                    <Row style={rowStyle}>
                      <Col sm={12}>
                        <Radio
                          value="original"
                          name="emailOriginal"
                          onChange={this.handleRadioChange}
                          checked={this.state.isChecked === "original"}
                        >
                          Email Original Images
                        </Radio>
                      </Col>
                    </Row>
                    {this.props.props.manageRedaction &&
                      this.state.hasRedaction && (
                        <Row style={rowStyle}>
                          <Col sm={12}>
                            <Radio
                              value="redacted"
                              name="emailRedacted"
                              onChange={this.handleRadioChange}
                              checked={this.state.isChecked === "redacted"}
                            >
                              Email Redacted Document
                            </Radio>
                          </Col>
                        </Row>
                      )}
                    {/* Email Input Fields */}
                    <Row style={rowStyle}>
                      <Col sm={4} componentClass={ControlLabel}>
                        Email To:
                      </Col>
                      <Col sm={8}>
                        <FormControl
                          className="input-box"
                          type="text"
                          required
                          onChange={(e) =>
                            this.setState({ emailInputField: e.target.value })
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={rowStyle}>
                      <Col sm={4} componentClass={ControlLabel}>
                        Cc:
                      </Col>
                      <Col sm={8}>
                        <FormControl
                          className="input-box"
                          type="text"
                          onChange={(e) =>
                            this.setState({ cc: e.target.value })
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={rowStyle}>
                      <Col sm={4} componentClass={ControlLabel}>
                        Bcc:
                      </Col>
                      <Col sm={8}>
                        <FormControl
                          className="input-box"
                          type="text"
                          onChange={(e) =>
                            this.setState({ bcc: e.target.value })
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={rowStyle}>
                      <Col sm={4} componentClass={ControlLabel}>
                        Link Delivery Type:
                      </Col>
                      <Col sm={8}>
                        <FormControl
                          componentClass="select"
                          value={this.state.deliveryMode}
                          onChange={(e) =>
                            this.setState({
                              deliveryMode: e.target.value,
                              bundleLinkName:
                                e.target.value === "singleBundleLink"
                                  ? this.state.bundleLinkName
                                  : "",
                            })
                          }
                        >
                          <option value="multipleLinks">
                            Send multiple links (one per file)
                          </option>
                          <option value="singleBundleLink">
                            Send one link for all files
                          </option>
                        </FormControl>
                      </Col>
                    </Row>
                    {this.state.deliveryMode === "singleBundleLink" && (
                      <Row style={rowStyle}>
                        <Col sm={4} componentClass={ControlLabel}>
                          Link Name:
                        </Col>
                        <Col sm={8}>
                          <FormControl
                            className="input-box"
                            type="text"
                            value={this.state.bundleLinkName}
                            required={
                              this.state.deliveryMode === "singleBundleLink"
                            }
                            onChange={(e) =>
                              this.setState({ bundleLinkName: e.target.value })
                            }
                          />
                        </Col>
                      </Row>
                    )}
                    {/* Link Expiration Selector */}
                    <Row style={rowStyle}>
                      <Col sm={6} componentClass={ControlLabel}>
                        Day(s) for Link Expiration:
                      </Col>
                      <Col sm={6}>
                        <FormControl
                          componentClass="select"
                          onChange={(e) =>
                            this.setState({ selectedDay: e.target.value })
                          }
                          required
                        >
                          <option key={-1} value="">
                            Select Day(s)
                          </option>
                          {[1, 5, 7, 10, 15, 30].map((day) => (
                            <option key={day} value={day}>
                              {day}
                            </option>
                          ))}
                        </FormControl>
                      </Col>
                    </Row>
                    {/* Submit Button */}
                    <LoaderButton
                      block
                      bsClass="btn btn-outline-secondary"
                      disabled={this.state.isLoading}
                      type="submit"
                      isLoading={this.state.isLoading}
                      text="Send Email"
                      loadingText="Sending Email..."
                    />
                  </FormGroup>
                </form>
              ) : (
                <form onSubmit={this.handleArchiveEmailSubmit}>
                  <Row style={rowStyle}>
                    <Col sm={4} componentClass={ControlLabel}>
                      Email To:
                    </Col>
                    <Col sm={8}>
                      <FormControl
                        className="input-box"
                        type="text"
                        required
                        onChange={(e) =>
                          this.setState({ emailInputField: e.target.value })
                        }
                      />
                    </Col>
                  </Row>
                  <Row style={rowStyle}>
                    <Col sm={4} componentClass={ControlLabel}>
                      Cc:
                    </Col>
                    <Col sm={8}>
                      <FormControl
                        className="input-box"
                        type="text"
                        onChange={(e) => this.setState({ cc: e.target.value })}
                      />
                    </Col>
                  </Row>
                  <LoaderButton
                    block
                    bsClass="btn btn-outline-secondary"
                    disabled={this.state.isLoading}
                    type="submit"
                    isLoading={this.state.isLoading}
                    text="Send Email"
                    loadingText="Sending Email..."
                  />
                </form>
              )}
            </div>
          </div>
        </Popup>
      </Fragment>
    );
  }
}

export default EmailPopup;
